import { ReactElement } from "react";
import { Box, Button, Image, VStack } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import NOT_FOUND_iMAGE_URL from "../assets/images/base/404notfound.png";
import { useDefaultPath } from "../hooks/useDefaultPath";

export function NotFound(): ReactElement {
  const defaultPath = useDefaultPath();

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
    >
      <VStack>
        <Image
          src={NOT_FOUND_iMAGE_URL}
          alt="not found"
          maxW="100%"
          maxH="100%"
        />
        <Button
          as={Link}
          to={defaultPath}
          variant="btn_primary"
          width="60%"
          fontSize="22"
        >
          Home
        </Button>
      </VStack>
    </Box>
  );
}
